<template>
  <div v-if="visible && atRoot && (loading || loadError || entries.length)" class="disk-quick">
    <div class="disk-quick-bar">
      <span class="disk-quick-label">
        <Icon type="ios-navigate-outline" size="16"></Icon>
        资料导航
      </span>
      <div v-if="loading" class="disk-quick-tip">加载导航…</div>
      <div v-else-if="loadError" class="disk-quick-tip">
        导航加载失败
        <a class="disk-group-nav-link" @click.prevent="reload">重试</a>
      </div>
      <div v-else class="disk-quick-items">
        <a v-for="item in entries" :key="item.key" class="disk-quick-item" :title="item.summary || item.title"
           @click="openNode(item.targetNodeId)">
          <img :src="folderIcon" alt="">
          <span>{{ item.title }}</span>
        </a>
      </div>
      <a v-if="entries.length" class="disk-quick-all" @click="drawerOpen = true">
        全部 {{ entries.length }} 个
        <Icon type="ios-arrow-right"></Icon>
      </a>
    </div>

    <div v-if="drawerOpen" class="disk-nav-drawer">
      <div class="disk-nav-drawer-head">
        <strong><Icon type="ios-navigate-outline" size="18"></Icon>教研群资料导航</strong>
        <a class="disk-nav-drawer-close" title="关闭" @click="drawerOpen = false"><Icon type="ios-close-empty" size="28"></Icon></a>
      </div>
      <div class="disk-nav-drawer-tools">
        <Input v-model="keyword" clearable icon="ios-search" placeholder="搜索导航入口"></Input>
        <div v-if="categories.length" class="disk-group-nav-cats">
          <span :class="['disk-group-nav-chip', { on: !categoryKey }]" @click="categoryKey = ''">全部</span>
          <span
            v-for="cat in categories"
            :key="cat.key"
            :class="['disk-group-nav-chip', { on: categoryKey === cat.key }]"
            @click="toggleCategory(cat.key)">
            {{ cat.title }}
            <a class="disk-group-nav-chip-open" title="打开此分类" @click.stop.prevent="openNode(cat.targetNodeId)">
              <Icon type="ios-folder-outline"></Icon>
            </a>
          </span>
        </div>
      </div>
      <div class="disk-nav-drawer-body">
        <div v-if="!filteredEntries.length" class="disk-group-nav-empty">
          没有匹配的入口
          <a v-if="hasFilter" class="disk-group-nav-link" style="margin-left: 8px" @click.prevent="clearFilter">查看全部</a>
        </div>
        <div
          v-for="item in filteredEntries"
          :key="item.key"
          class="disk-group-nav-card"
          @click="openNode(item.targetNodeId)">
          <img :src="folderIcon" alt="" class="disk-group-nav-card-icon">
          <div class="disk-group-nav-card-main">
            <div class="disk-group-nav-card-title" :title="item.title">{{ item.title }}</div>
            <div v-if="item.summary" class="disk-group-nav-card-summary">{{ item.summary }}</div>
            <div class="disk-group-nav-card-path">{{ item.pathLabel || './' }}</div>
          </div>
          <Spin v-if="openingId === item.targetNodeId" size="small"></Spin>
          <Icon v-else type="ios-arrow-right" class="disk-group-nav-card-arrow"></Icon>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {iconFolder} from './fileIcon'

  export default {
    name: 'DiskGroupNav',
    props: {
      groupId: {
        type: [Number, String],
        default: null
      },
      rootNodeId: {
        type: [Number, String],
        default: null
      },
      currentFolderId: {
        type: [Number, String],
        default: null
      }
    },
    data () {
      return {
        folderIcon: iconFolder,
        loading: false,
        loadError: false,
        categories: [],
        entries: [],
        categoryKey: '',
        keyword: '',
        drawerOpen: false,
        openingId: null,
        openSeq: 0,
        loadedGroupId: null
      }
    },
    computed: {
      visible () {
        return Number(this.groupId) === 1
      },
      atRoot () {
        if (this.rootNodeId == null || this.currentFolderId == null) {
          return false
        }
        return Number(this.rootNodeId) === Number(this.currentFolderId)
      },
      hasFilter () {
        return !!(this.categoryKey || (this.keyword || '').trim())
      },
      filteredEntries () {
        let list = this.entries || []
        if (this.categoryKey) {
          list = list.filter(e => e.categoryKey === this.categoryKey)
        }
        let kw = (this.keyword || '').trim().toLowerCase()
        if (!kw) {
          return list
        }
        return list.filter(e => {
          let blob = [e.title, e.summary].concat(e.keywords || []).join(' ').toLowerCase()
          return blob.indexOf(kw) !== -1
        })
      }
    },
    watch: {
      groupId: {
        immediate: true,
        handler (val) {
          this.drawerOpen = false
          if (Number(val) === 1) {
            this.ensureLoaded()
          } else {
            this.categories = []
            this.entries = []
            this.loadedGroupId = null
          }
        }
      }
    },
    methods: {
      toggleCategory (key) {
        this.categoryKey = this.categoryKey === key ? '' : key
      },
      clearFilter () {
        this.categoryKey = ''
        this.keyword = ''
      },
      ensureLoaded () {
        if (!this.visible) {
          return
        }
        if (this.loadedGroupId === Number(this.groupId) && (this.entries.length || this.categories.length) && !this.loadError) {
          return
        }
        this.reload()
      },
      reload () {
        let self = this
        if (!self.visible) {
          return
        }
        self.loading = true
        self.loadError = false
        self.$http.get('/disk/nav/config', {params: {groupId: 1}}).then(function (res) {
          self.loading = false
          if (res && res.status === 'ok' && res.data) {
            self.categories = res.data.categories || []
            self.entries = res.data.entries || []
            self.loadedGroupId = 1
            self.loadError = false
          } else {
            self.loadError = true
          }
        }).catch(function () {
          self.loading = false
          self.loadError = true
        })
      },
      openNode (nodeId) {
        let self = this
        if (!nodeId) {
          self.$Message.error('该入口已不可用，请联系维护人更新导航')
          return
        }
        let seq = ++self.openSeq
        self.openingId = nodeId
        self.$http.get('/disk/nav/open', {params: {groupId: 1, nodeId: nodeId}}).then(function (res) {
          if (seq !== self.openSeq) {
            return
          }
          self.openingId = null
          if (res && res.status === 'ok' && res.data) {
            self.drawerOpen = false
            self.$emit('open-target', res.data)
          }
          // 非 ok：Http 拦截器已 Message.error(data.msg)，此处不再重复弹
        }).catch(function () {
          if (seq !== self.openSeq) {
            return
          }
          self.openingId = null
          // 网络层错误拦截器已提示「系统繁忙」
        })
      }
    }
  }
</script>

<style scoped>
  .disk-quick {
    margin-bottom: 12px;
  }
  .disk-quick-bar {
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 6px 0 14px;
    border: 1px solid #eef0f4;
    border-radius: 10px;
    background: #f7f9fc;
  }
  .disk-quick-label {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    gap: 4px;
    margin-right: 12px;
    color: #808695;
    font-size: 13px;
  }
  .disk-quick-tip {
    flex: 1;
    color: #a8adb7;
    font-size: 13px;
  }
  .disk-quick-items {
    display: flex;
    flex: 1;
    min-width: 0;
    overflow: hidden;
    -webkit-mask-image: linear-gradient(90deg, #000 85%, transparent);
    mask-image: linear-gradient(90deg, #000 85%, transparent);
  }
  .disk-quick-item {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    max-width: 200px;
    height: 30px;
    margin-right: 6px;
    padding: 0 10px 0 6px;
    border-radius: 8px;
    background: #fff;
    border: 1px solid #eef0f4;
    color: #17233d;
    font-size: 13px;
  }
  .disk-quick-item:hover {
    border-color: #2d8cf0;
    color: #2d8cf0;
  }
  .disk-quick-item img {
    width: 20px;
    height: 20px;
    margin-right: 6px;
  }
  .disk-quick-item span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .disk-quick-all {
    display: inline-flex;
    align-items: center;
    flex: 0 0 auto;
    height: 30px;
    margin-left: 6px;
    padding: 0 10px;
    border-radius: 8px;
    color: #2d8cf0;
    font-size: 13px;
    white-space: nowrap;
  }
  .disk-quick-all:hover {
    background: #e3eeff;
  }
  .disk-group-nav-link {
    color: #2d8cf0;
    cursor: pointer;
    font-size: 13px;
  }
  .disk-nav-drawer {
    position: fixed;
    top: 64px;
    right: 24px;
    bottom: 24px;
    z-index: 910;
    display: flex;
    flex-direction: column;
    width: 420px;
    max-width: calc(100vw - 48px);
    background: #fff;
    border: 1px solid #eef0f4;
    border-radius: 12px;
    box-shadow: 0 12px 40px rgba(23, 35, 61, 0.16);
  }
  .disk-nav-drawer-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 12px 8px 20px;
  }
  .disk-nav-drawer-head strong {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 16px;
    color: #17233d;
  }
  .disk-nav-drawer-close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    color: #808695;
  }
  .disk-nav-drawer-close:hover {
    background: #eef2f8;
  }
  .disk-nav-drawer-tools {
    padding: 0 20px 8px;
  }
  .disk-nav-drawer-tools /deep/ .ivu-input {
    border-radius: 16px;
  }
  .disk-group-nav-cats {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
  }
  .disk-group-nav-chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 10px;
    border-radius: 14px;
    background: #f5f7fa;
    color: #515a6e;
    font-size: 12px;
    cursor: pointer;
  }
  .disk-group-nav-chip:hover {
    color: #2d8cf0;
  }
  .disk-group-nav-chip.on {
    color: #fff;
    background: #2d8cf0;
  }
  .disk-group-nav-chip-open {
    display: inline-flex;
    color: inherit;
    opacity: 0.7;
  }
  .disk-group-nav-chip-open:hover {
    opacity: 1;
  }
  .disk-nav-drawer-body {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 4px 12px 16px;
  }
  .disk-group-nav-empty {
    padding: 40px 0;
    color: #a8adb7;
    font-size: 13px;
    text-align: center;
  }
  .disk-group-nav-card {
    display: flex;
    align-items: center;
    padding: 10px 8px;
    border-radius: 10px;
    cursor: pointer;
  }
  .disk-group-nav-card:hover {
    background: #f0f6ff;
  }
  .disk-group-nav-card-icon {
    width: 32px;
    height: 32px;
    flex: 0 0 32px;
    margin-right: 12px;
  }
  .disk-group-nav-card-main {
    flex: 1;
    min-width: 0;
  }
  .disk-group-nav-card-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #17233d;
    font-size: 14px;
    font-weight: 500;
  }
  .disk-group-nav-card-summary {
    margin-top: 2px;
    color: #808695;
    font-size: 12px;
    line-height: 1.5;
  }
  .disk-group-nav-card-path {
    margin-top: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #a8adb7;
    font-size: 12px;
  }
  .disk-group-nav-card-arrow {
    margin-left: 8px;
    color: #c5c8ce;
  }
</style>



// WEBPACK FOOTER //
// DiskGroupNav.vue?172fff20